import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import {
    showProjectBusPriorityLoader,
    onSaveProjectBusPriority,
    onProjectBusPriorityClose,
} from 'actions/projectBusPriority';
import { inputFields, displayedImage, showErrors, modalHeader, isFormValid, getFormError } from '../common';

const ProjectBusPriorityEdit = () => {
    const dispatch = useDispatch();
    const editProjectBusPriorityState = useSelector(state => state.projectBusPrioritys.editProjectBusPriorityState);
    const projectBusPriority = useSelector(state => state.projectBusPrioritys.selectedProjectBusPriority);
    const [selectedProjectBusPriority, setSelectedProjectBusPriority] = useState(projectBusPriority);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    // using selectedProjectBusPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectBusPriority changes
    useEffect(() => {
        setSelectedProjectBusPriority(projectBusPriority);
        setFormValid(false);
        validateForm();
    }, [projectBusPriority]);

    // using selectedProjectBusPriority makes it behave like componentDidUpdate - effect takes place when selectedProjectBusPriority changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedProjectBusPriority]);

    const handleUserInput = (event, isNumber) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isNumber) {
            value = Number(event.target.value);
        }
        updateSelectedProjectBusPriorityField(name, value);
        validateField(name, value);
    };

    const updateSelectedProjectBusPriorityField = (fieldName, value) => {
        const newProjectBusPriority = { ...projectBusPriority };
        newProjectBusPriority[fieldName] = value;
        setSelectedProjectBusPriority(newProjectBusPriority);
    };

    const validateField = (fieldName, value) => {
        formErrors[fieldName] = getFormError(fieldName, value);
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isFormValid(selectedProjectBusPriority));
    };


    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showProjectBusPriorityLoader());
                dispatch(onProjectBusPriorityClose());
                dispatch(onSaveProjectBusPriority(selectedProjectBusPriority));
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onProjectBusPriorityClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedProjectBusPriority)}
                        {showErrors(formErrors)}
                        {inputFields(projectBusPriority, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={editProjectBusPriorityState}>
            {modalHeader(<IntlMessages id="projectBusPriority.saveProjectBusPriority" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="projectBusPriority.saveProjectBusPriority" />)}
        </Modal>
    );
};

export default ProjectBusPriorityEdit;


// WEBPACK FOOTER //
// ./components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityEdit/index.js